import { createSelector } from '@ngrx/store';
import { CollectionsState, getCollectionsState } from '../collections.reducer';

export const getChatbotState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.chatbot,
);

export const getChatSessionState = createSelector(getChatbotState, (state) => state);

export const getBarTitle = createSelector(getChatbotState, (state) => state.barView?.title ?? null);

export const getChatbotThreadID = createSelector(getChatbotState, (state) => state.threadId);

export const getBarCriteria = createSelector(
  getChatbotState,
  (state) => state.barView?.criteria ?? [],
);

export const getGatheringProgress = createSelector(
  getChatbotState,
  (state) => state.gatheringProgress ?? null,
);

export const getEditableCriteria = createSelector(
  getChatbotState,
  (state) => state.draftCriteria ?? state.barView?.criteria ?? [],
);

export const getHasStagedChanges = createSelector(
  getChatbotState,
  (state) => state.draftCriteria !== null || (state.barView?.stagedChanges ?? null) !== null,
);

export const getIsStagedWritePending = createSelector(
  getChatbotState,
  (state) => state.isStagedWritePending,
);

export const getIsApplyingStagedChanges = createSelector(
  getChatbotState,
  (state) => state.isApplyingStagedChanges,
);

export const getIsReviewingAndSearching = createSelector(
  getChatbotState,
  (state) => state.isReviewingAndSearching,
);

export const getProgressLog = createSelector(getChatbotState, (state) => state.progressLog ?? []);

export const getProgressHolds = createSelector(
  getChatbotState,
  (state) => state.progressHolds ?? [],
);

export const getStreamingReply = createSelector(
  getChatbotState,
  (state) => state.streamingReply ?? '',
);

export const getStreamingReplyComplete = createSelector(
  getChatbotState,
  (state) => state.streamingReplyComplete ?? false,
);

export const getReplyStreamOpened = createSelector(
  getChatbotState,
  (state) => state.replyStreamOpened ?? false,
);

// The narration that arrived after the reply settled (or after a withdrawn attempt): it
// renders under the bubble, where the lines that preceded the reply must not repeat.
export const getPostReplyProgress = createSelector(getChatbotState, (state) => {
  const from = state.progressTailFrom ?? -1;
  return from >= 0 ? (state.progressLog ?? []).slice(from) : [];
});
